import React      from 'react';
import { Helmet } from 'react-helmet';

const links = [
    'https://origin-static.ncplatform.net/fonts/cronos/v1/cronos-light-min.css',
    'https://origin-static.ncplatform.net/fonts/cronos/v1/cronos-regular-min.css',
    'https://origin-static.ncplatform.net/fonts/cronos/v1/cronos-bold-min.css',
    'https://origin-static.ncplatform.net/fonts/cronos/v1/cronos-italic-min.css',
    'https://origin-static.ncplatform.net/fonts/cronos/v1/cronos-bolditalic-min.css',
    'https://origin-static.ncplatform.net/fonts/eason/v1/eason-regular-min.css',
    'https://origin-static.ncplatform.net/fonts/eason/v1/eason-italic-min.css',
    'https://origin-static.ncplatform.net/fonts/eason/v1/eason-bold-min.css',
    'https://origin-static.ncplatform.net/fonts/eason/v1/eason-displaycaps-min.css',
    'https://use.typekit.net/dpy4rht.css'
].map(href => ({
    href,
    rel : 'stylesheet'
}));

export default function SEO({ lang, metatags, title }) {
    return (
        <Helmet
            link={links}
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={'%s'}
            meta={
                Object.entries(metatags).map(([ property, content ]) => {
                    let obj = { content };

                    if (property === 'description' || property.indexOf('twitter') === 0) {
                        obj.name = property;
                    } else {
                        obj.property = property;
                    }

                    return obj;
                })
                    .concat([{ name : 'twitter:card', content : 'summary' }])
            }
        />
    );
}
